<template>
  <div class="text-center max-display">
    <div class="flex justify-center items-end">
      <span class="text-white inline-block">Jeremy, 4?? That's </span>
      <div class="wavy -mb-1 ml-1">
        <span class="text-white" style="--i:1;">i</span>
        <span class="text-white" style="--i:2;">n</span>
        <span class="text-white" style="--i:3;">s</span>
        <span class="text-white" style="--i:4;">a</span>
        <span class="text-white" style="--i:5;">n</span>
        <span class="text-white" style="--i:6;">e</span>
        <span class="text-white" style="--i:7;">!</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InsaneAnimationComponent'
}
</script>
<style scoped>

.wavy {
  animation: scale-text 5s;
}

.wavy span {
  font-size: 1.75rem;
  display: inline-block;
  color: #9b2c2c;
  line-height: 1;
  animation: animate-text 2s ease-in-out infinite;
  animation-delay: calc(0.1s * var(--i));
}

@keyframes scale-text {
  0% {
    transform: scale(1) translateX(0px);
  }
  20% {
    transform: scale(1.4) translateX(30px) translateY(10px);
  }
  40%, 100% {
    transform: scale(1) translateX(0px) translateY(0px);
  }
}
@keyframes animate-text {
  0% {
    transform: translateY(0px);
    color: #FF00FF;
  }
  20% {
    transform: translateY(-10px);
    color: #FFF200;
  }
  60% {
    color: #01FFFF;
  }
  40%, 100% {
    transform: translateY(0px);
    color: #00FF02;
  }
}
</style>